export default __webpack_public_path__ + "static/media/bubu.0e846ce7.gif";